import React, { useCallback } from 'react';
import {
    required,
    minLength,
    maxLength,
    minValue,
    maxValue,
    number,
    regex,
    email,
    choices, Button,
    Edit, SimpleForm, TextInput,ReferenceInput, SelectInput,
    DateInput, BooleanInput, NumberInput,FileInput, FileField,
    ImageInput, ImageField, SaveButton, Toolbar, DeleteButton
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import { useForm } from 'react-final-form';
import CancelIcon from '@material-ui/icons/Cancel';
import SaveIcon from '@material-ui/icons/Save';
import * as apiClient from "../../common/apiClient";
import CreateToolbar from "../../CreateToolbar";
import { makeStyles } from '@material-ui/core/styles';
import { useStyles } from "../../formStyles";

import moment from "moment";
const PostCreateToolbar = props => (
    
    <Toolbar {...props}>
        <SaveButton submitOnEnter={true}  onSave={props.onSave} />
        <Button
        variant="contained" color="primary"
        label="Back" size="medium"
        startIcon={<CancelIcon />}
        style={{marginLeft:"30px"}}
        onClick={props.onCancel}
        />
    </Toolbar>
);
const EditFOPayment = props => {
    const classes = useStyles({});
    
    const handleSubmit = async (formdata) => {
         console.log(formdata);
         let user = localStorage.getItem("userId");
         if (user) {
           user = parseInt(user);
         }
         let m = moment();
         let data = formdata;
         data.modifyBy = user;
         
         data.modifydate = m.toISOString();      
  

        console.log(data);
         Object.keys(data).forEach((item) => {
                    if (data[item] == null || data[item] == undefined)
                        delete data[item];
                });        
                apiClient.updateEntiyRecord("tpafo-fee-dets", data).then(res => {
                    props.onClose();
                }).catch(err => {
                    console.log(err);
                });       
        
    }
    return (
        
            <Edit {...props} id={props.selectedId} resource="tpafo-fee-dets" redirect={false}>
            <SimpleForm onSubmit={handleSubmit} 
                toolbar={<PostCreateToolbar onSave={handleSubmit} onCancel={props.onCancel}   />} variant="outlined"> 
                <ReferenceInput  perPage={2000} source="policyTypeId" label="Policy Type" reference="lookups"  fullWidth={true}  sort={{ field: 'name', order: 'ASC' }} filter={{ type: 'TCLM' }} >
                    <SelectInput optionText="name" validate={required()} />
                </ReferenceInput>  
                <BooleanInput source="isInsured" label="Insured" initialValue={true} fullWidth={true}  />
                <BooleanInput source="isHospitalised" label="Hospitalised" initialValue={true}  fullWidth={true} />
                <BooleanInput source="iscompleted" label="Is Completed" initialValue={true} fullWidth={true}  />
                <NumberInput  validate={required()} fullWidth={true}  source="professionalFee" label="Professional Fee" fullWidth={true} />   
                <TextInput  fullWidth={true}   source="remarks" label="Remarks" initialValue=""  />  

            </SimpleForm>
        </Edit>
    );
}
export default EditFOPayment;